import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Table,
  ButtonGroup,
  Dropdown,
} from 'semantic-ui-react';

import _ from 'lodash';

const headerCellStyle = {
  height: 51,
};
const contentStyles = { paddingTop: '20px' };
const btnStyles = { border: 'none', width: '80%' };
const dropdownStyles = { display: 'flex', alignItems: 'center' };

const countryFilters = [
  { code: 'DE', name: 'Germany' },
  { code: 'FR', name: 'France' },
  { code: 'IT', name: 'Italy' },
  { code: 'ES', name: 'Spain' },
];

const statusOptions = [
  { key: 'approved', text: 'Approved', value: 'approved' },
  { key: 'rejected', text: 'Rejected', value: 'rejected' },
];

const activeColor = '#fc4085';
const defaultColor = '#1d1937';
export default function ApprovalFilter({ onFilterChanged, selectedFilter }) {
  const getGroupStyles = value => {
    const isActive = value === _.get(selectedFilter, 'country', '');
    return (isActive ? {
      color: activeColor,
      border: `2px solid ${activeColor}`,
      fontWeight: 600,
      width: '100%',
    } : {
      color: defaultColor,
      border: `2px solid ${defaultColor}`,
      fontWeight: 600,
      width: '100%',
    });
  };
  const getButtonTitle = country => {
    const isActive = country.code === _.get(selectedFilter, 'country', '');
    const showStatus = isActive && selectedFilter.status;
    return (<div style={{ display: 'flex', flexDirection: 'column', color: isActive ? activeColor : defaultColor }}>
      <span>{country.name}</span>
      {showStatus && <span style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.4)' }}>({selectedFilter.status})</span>}
    </div>);
  };
  return (
    <Table>
      <Table.Header fullWidth>
        <Table.Row>
          <Table.HeaderCell width={8} style={headerCellStyle}>
            Filter by country
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell colSpan={2}>
            <Grid padded style={contentStyles}>
              {
                _.map(countryFilters, country =>
                  <Grid.Row key={country.code}>
                    <Grid.Column>
                      <ButtonGroup basic style={getGroupStyles(country.code)} compact>
                        <Button
                          style={btnStyles}
                          onClick={() => onFilterChanged({ country: country.code, status: null })}
                          size="large"
                        >
                          {getButtonTitle(country)}
                        </Button>
                        <Dropdown
                          className="button icon"
                          style={dropdownStyles}
                          options={statusOptions}
                          floating
                          onChange={(e, data) => { onFilterChanged({ country: country.code, status: data.value }); }}
                          trigger={<div />}
                        />
                      </ButtonGroup>
                    </Grid.Column>
                  </Grid.Row>)
              }
            </Grid>
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>);
}

ApprovalFilter.propTypes = {
  onFilterChanged: PropTypes.func,
  selectedFilter: PropTypes.object,
};
ApprovalFilter.defaultProps = {
  onFilterChanged: _.noop,
  selectedFilter: {},
};



/** WEBPACK FOOTER **
 ** ./src/components/approval-filter/index.js
 **/